export default "__VITE_ASSET__1aXHYhc1__"